module.exports = __webpack_public_path__ + "media/bgm_main_jp.d6f492c3.m4a";